import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-plus",
  "use": "icon-plus-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-plus\"><path d=\"M12 7.499H8.5v-3.5h-1v3.5H4v1h3.5v3.5h1v-3.5H12z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol